import { Accordion, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconUsersGroup } from "@tabler/icons-react";
import React from "react";
import NewsletterListsListingTable from "./NewsletterListsListingTable";
import { useLanguage } from "../../../stores/LanguageStore";

const NewsletterList = ({ contactListIds, setContactListIds }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Accordion
      variant="contained"
      bg={"#fff"}
      radius={"xl"}
      defaultValue={"list"}
      mt={"md"}
    >
      <Accordion.Item value="list">
        <Accordion.Control>
          <Group>
            <ThemeIcon variant="light" size={"xl"} radius={"xl"}>
              <IconUsersGroup />
            </ThemeIcon>
            <Stack gap={0}>
              <Text fw={600}>{lang.newsletter.step_1_title}</Text>
              <Text c="dimmed">{lang.newsletter.step_1_desc}</Text>
            </Stack>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <NewsletterListsListingTable
            selectionModel={contactListIds}
            onSelectionChange={setContactListIds}
          />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default NewsletterList;
